import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header.js";
import GreyArrow from "../assets/greyLeftAr.png";
import { Modal } from "react-bootstrap";
import { X, Info, ArrowLeft } from "lucide-react";
import { goBack } from "../CommonJquery/CommonJquery.js";
import { Button } from "@mui/material";
import { APL_LINK } from "../ServiceConnection/serviceconnection.js";
import { FaOilCan } from "react-icons/fa";

export default function ViewOilCheck() {
  const location = useLocation();
  const { data, ImageLink } = location.state || {};
  const RepairData = data;

  // Dummy data for design demonstration
  const dummyRepairData = {
    repair_reason: "Engine Overheating",
    assign_staff_name: "John Smith",
    name_and_issue: "Toyota Camry - Coolant leak causing overheating",
    odometer_reading: "85,432",
    odometer_image: "odometer_sample.jpg",
    vehicle_image1: "vehicle_front.jpg",
    vehicle_image2: "vehicle_back.jpg",
    vehicle_image3: "vehicle_left.jpg",
    vehicle_image4: "vehicle_right.jpg",
    damage_status: "someDamage",
    damage_image1: "damage_front_bumper.jpg",
    damage_image2: "damage_side_panel.jpg",
    damage_image3: "damage_rear_light.jpg",
    damage_image4: "damage_interior.jpg",
    repair_notes:
      "Replaced radiator hose and refilled coolant. Minor scratches on front bumper need attention. Vehicle tested and running normally.",
    damage_charges: "250.00",
  };

  // Use dummy data if no real data is provided (for design purposes)
  const displayData = RepairData || dummyRepairData;

  // Modal state for image viewing
  const [showModal, setShowModal] = useState(false);
  const [ImAgeShowlist, setImAgeShowlist] = useState([]);

  const openModal = (image) => {
    setImAgeShowlist(image);
    setShowModal(true);
  };

  const closeModal = () => setShowModal(false);

  // General Info Section
  const generalInfoSection = () => {
    return (
      <div className="check-section mb-4">
        <div className="section-header d-flex justify-content-between align-items-center mb-2">
          <h3 className="section-title">
            <Info size={18} className="iconViewMaintn" /> General Info
          </h3>
        </div>
        <div className="section-content card">
          <div className="card-body">
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Reason</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                {/* <span className="field-value">{displayData.repair_reason}</span> */}
                <span className="field-value">Oil Check</span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Done By</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{displayData.assign_staff_name}</span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Issue with the car
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">{displayData.name_and_issue}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Repair Step 2 Section
  const repairStep2Section = () => {
    return (
      <div className="check-section mb-4">
        <div className="section-header d-flex justify-content-between align-items-center mb-2">
          <h3 className="section-title">
            <FaOilCan size={18} className="iconViewMaintn" /> Oil Check
          </h3>
        </div>
        <div className="section-content card">
          <div className="card-body">
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Oil Level</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {displayData.oil_level || "0.00"}
                </span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Oil Quality
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {displayData.oil_quantity || "N/A"}
                </span>
              </div>
            </div>
            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">
                Oil Quantity Added
              </label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <span className="field-value">
                  {displayData.oil_added_quantity || "N/A"}
                </span>
              </div>
            </div>

            <div className="field-row row border-bottom py-2">
              <label className="field-label col-sm-7 col-md-8">Oil Cap Image</label>
              <div className="field-value-container col-sm-5 col-md-4 text-end">
                <div className="code_img_cntr">
                  <div className="col-3" style={{ marginRight: "10px" }}>
                    <img
                      src={
                        APL_LINK + ImageLink + displayData.picture_of_closed_oil
                      }
                      onError={(e) => {
                        e.target.style.display = "none";
                      }}
                      alt={`Oil Cap`}
                      className="Img_contr_code_main"
                      onClick={() =>
                        openModal(displayData.picture_of_closed_oil)
                      }
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <Header />
      <div className="container-lg">
        <div className="pageCntn_head">
          <div className="pageNameDiv">
            <div className="d-flex gap-2 align-items-center">
              <p>View Repair Details</p>
              <img
                src={GreyArrow}
                alt="Rapid Car Leasing"
                style={{ height: "14px" }}
              />
            </div>
          </div>
          <Button
            onClick={goBack}
            startIcon={<ArrowLeft size={17} style={{ marginBottom: "2px" }} />}
            className="Back_bttn_page"
          >
            Back
          </Button>
        </div>
      </div>

      <div className="container-lg">
        <div className="final-checks-container2">
          <div className="row">
            <div className="col-md-6">{generalInfoSection()}</div>
            <div className="col-md-6">{repairStep2Section()}</div>
          </div>
        </div>
      </div>

      <Modal
        className="code_reading_modal"
        show={showModal}
        onHide={closeModal}
        centered
      >
        <Modal.Body className="text-center position-relative">
          <X size={24} className="close_bttn_mdl" onClick={closeModal} />

          <img
            src={APL_LINK + ImageLink + ImAgeShowlist}
            alt="Selected"
            className="img-fluid modal-img coade_iMg"
          />
        </Modal.Body>
      </Modal>
    </div>
  );
}
